export default {
    newPageCreateFile: "Création du fichier",
    globalConfirm: "Confirmer",
    globalCancel: "Annuler",
    globalStyle: "Style",
    globalColor: "Couleur",
    globalLine: "Ligne",
};
